// extracted by mini-css-extract-plugin
export default {"wrapper":"StarRating_wrapper__nxx45","stars":"StarRating_stars__SKlw8","filled":"StarRating_filled__vSXpX","empty":"StarRating_empty__8bSCZ","count":"StarRating_count__XPzDc"};